export const encode = (info: any) => {
  return btoa(JSON.stringify(info));
};
export const decode = (cod: any) => {
  return JSON.parse(atob(cod));
};
